<template>
<div class="youtube-responsive" :style="styleObject">
  <div class="aspect">
    <div class="content">
      <iframe :title="vidTittle" v-if="youtubeEmbed" width="100%" height="100%" :src="'https://www.youtube.com/embed/'+youtubeEmbed" frameborder="0" allow="autoplay" allowfullscreen></iframe>
      <video id="video1" :title="vidTittle" v-if="videoEmbed" width="100%" height="100%" autoplay controls>
          <source :src="videoPath" type="video/mp4">
        </video>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    youtubeEmbed: {
      type: String,
      required: false
    },
    videoEmbed: {
      type: String,
      required: false
    },
    videoSize: {
      Type: Number,
      required: false
    },
    vidTittle: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      videoPath: this.videoEmbed ? require('../../assets/videos/' + this.videoEmbed) : '',
      styleObject: {
        maxWidth: this.videoSize + "px",
      }
    }
  },
  mounted() {
    // @link: https://stackoverflow.com/questions/44321110/youtube-full-screen-video-behind-html-content
    var video = document.getElementById("video1");
    var all = []

    function onFullScreen(e) {
      console.log('e', e);
      var isFullscreenNow = document.webkitFullscreenElement !== null
      console.log('Fullscreen ', isFullscreenNow)
      if (isFullscreenNow) {
        setInterval(function() {
          all = document.getElementsByClassName("animated");
          for (var i = 0; i < all.length; i++) {
            // var ele = all[i];
            // ele.classList.remove('animated');
          }
        }, 2000);
      } else {
        for (var i = 0; i < all.length; i++) {
          // var ele = all[i];
          // ele.classList.add('animated');
        }
      }
      // ;
      // setInterval(function () {
      //   for (var i = 0; i < all.length; i++) {
      //     var ele = all[i];
      //     ele.classList.remove('animated');
      //   }
      // }, 1000);
    }
    if(video !== null)
      video.addEventListener('webkitfullscreenchange', onFullScreen);
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
.youtube-responsive {
    margin: auto;
    position: relative;
    max-width: 800px;
    width: 100%;
    .aspect {
        @include aspect-ratio(16, 9);
    }
}
// .wpb_start_animation.animated {
//     animation-fill-mode: backwards;
// }
// .wpb_start_animation.animated {
//    animation-fill-mode: none;
// }

:-webkit-full-screen-ancestor:not(iframe) {
    .animated {
        -webkit-animation-fill-mode: none;
        animation-fill-mode: none;
    }
}
</style>



// WEBPACK FOOTER //
// Videoimport.vue?470fcbbc